module.exports = true;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_library.js
// module id = 78
// module chunks = 0